var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.loading
        ? _c("div", [
            _c("div", [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c(
                      "v-row",
                      [
                        _c("v-col", { attrs: { cols: "6" } }, [
                          _c("small", { staticClass: "text-secondary" }, [
                            _vm._v(" Ativo ")
                          ]),
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              " " + _vm._s(_vm.ativo.nome_ativo || "—") + " "
                            )
                          ])
                        ]),
                        _c("v-col", { attrs: { cols: "6" } }, [
                          _c("small", { staticClass: "text-secondary" }, [
                            _vm._v(" Classe ")
                          ]),
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.ativo.classe || _vm.ativo.CI || "-"
                                ) +
                                " "
                            )
                          ])
                        ]),
                        _vm.ativo.subclasse
                          ? _c("v-col", { attrs: { cols: "6" } }, [
                              _c("small", { staticClass: "text-secondary" }, [
                                _vm._v(" Subclasse ")
                              ]),
                              _c("p", { staticClass: "mb-0" }, [
                                _vm._v(" " + _vm._s(_vm.ativo.subclasse) + " ")
                              ])
                            ])
                          : _vm._e(),
                        _c("v-col", { attrs: { cols: "6" } }, [
                          _c("small", { staticClass: "text-secondary" }, [
                            _vm._v(" Tipo ")
                          ]),
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.ativo.tipo || _vm.ativo.Tipo || "-"
                                ) +
                                " "
                            )
                          ])
                        ]),
                        _vm.ativos.length
                          ? _c("v-col", { attrs: { cols: "6" } }, [
                              _c("small", { staticClass: "text-secondary" }, [
                                _vm._v(" Quantidade de ativos ")
                              ]),
                              _c("p", { staticClass: "mb-0" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.ativos.length) +
                                    " ativo" +
                                    _vm._s(_vm.ativos.length > 1 ? "s" : "") +
                                    " "
                                )
                              ])
                            ])
                          : _vm._e(),
                        _c("v-col", { attrs: { cols: "6" } }, [
                          _c("small", { staticClass: "text-secondary" }, [
                            _vm._v(" Data de atualização ")
                          ]),
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(" " + _vm._s(_vm.dataReferencia) + " ")
                          ])
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-8", staticStyle: { height: "300px" } },
                  [
                    _vm.ativos.length
                      ? _c("ShowComposition", {
                          attrs: { values: _vm.dadosGrafico, "center-text": "" }
                        })
                      : _vm._e(),
                    !_vm.ativos.length
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center justify-content-center",
                            staticStyle: { height: "100%" }
                          },
                          [
                            _c("p", { staticClass: "text-bold" }, [
                              _vm._v(
                                " Nenhum ativo adicionado na composição do ativo. "
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]),
            _vm.ativos.length
              ? _c(
                  "div",
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center" },
                      [
                        _c("v-select", {
                          staticStyle: { "max-width": "150px" },
                          attrs: {
                            items: _vm.opcoesAgrupamento,
                            label: "Agrupar por",
                            "hide-details": ""
                          },
                          model: {
                            value: _vm.agruparPor,
                            callback: function($$v) {
                              _vm.agruparPor = $$v
                            },
                            expression: "agruparPor"
                          }
                        }),
                        _c("v-spacer"),
                        _c("div", { staticClass: "mr-3" }, [
                          _c("small", { staticClass: "text-secondary" }, [
                            _vm._v(" Total alocado: ")
                          ]),
                          _c(
                            "p",
                            {
                              staticClass: "mb-0 text-bold",
                              class: { "text-danger": _vm.percentTotal !== 100 }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.toPercent(_vm.percentTotal)) +
                                  " "
                              )
                            ]
                          )
                        ]),
                        _c("v-text-field", {
                          staticClass: "align-icon-search",
                          staticStyle: { "max-width": "250px" },
                          attrs: {
                            placeholder: "Pesquisar",
                            filled: "",
                            "append-icon": "mdi-magnify",
                            "hide-details": ""
                          },
                          model: {
                            value: _vm.textFilter,
                            callback: function($$v) {
                              _vm.textFilter = $$v
                            },
                            expression: "textFilter"
                          }
                        })
                      ],
                      1
                    ),
                    _c("v-data-table", {
                      staticClass: "mt-2",
                      staticStyle: { background: "transparent" },
                      attrs: {
                        items: _vm.ativos,
                        headers: _vm.headers,
                        height: 300,
                        "fixed-header": "",
                        "group-by": _vm.agruparPor,
                        search: _vm.textFilter
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "item.alocacao_percentual",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.toPercent(item.alocacao_percentual)
                                      ) +
                                      " "
                                  )
                                ])
                              ]
                            }
                          },
                          {
                            key: "item.actions",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _vm.podeEditar
                                  ? _c(
                                      "div",
                                      { staticClass: "d-flex" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { icon: "", small: "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.openEdit(item)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: "primary"
                                                }
                                              },
                                              [_vm._v(" mdi-pencil ")]
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { icon: "", small: "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.unFixAsset(item)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: "red"
                                                }
                                              },
                                              [_vm._v(" mdi-close ")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2225258876
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.podeEditar
              ? _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _c("v-spacer"),
                    _c(
                      "BaseButton",
                      { attrs: { underlined: "" }, on: { click: _vm.close } },
                      [_vm._v(" Cancelar ")]
                    ),
                    _c(
                      "BaseButton",
                      {
                        attrs: { outline: "", primary: "" },
                        on: { click: _vm.abrirSelecionarAtivo }
                      },
                      [_vm._v(" Incluir ativo ")]
                    ),
                    _vm.ativos.length
                      ? _c(
                          "BaseButton",
                          {
                            attrs: {
                              primary: _vm.podeSalvar,
                              secondary: !_vm.podeSalvar
                            },
                            on: { click: _vm.save }
                          },
                          [_vm._v(" Salvar ")]
                        )
                      : _vm._e(),
                    _c("v-spacer")
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm.loading
        ? _c(
            "div",
            {
              staticClass: "d-flex align-items-center justify-content-center",
              staticStyle: { height: "40vh" }
            },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary", size: "48" }
              })
            ],
            1
          )
        : _vm._e(),
      _c("AtivoShort", { attrs: { bus: _vm.bus, fixados: _vm.ativos } }),
      _c("AtivoLong", { attrs: { bus: _vm.bus, fixados: _vm.ativos } }),
      _c("EditarAtivo", { attrs: { bus: _vm.bus } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }